import type { RouteRecordRaw } from 'vue-router'
import {
  toAnyPermission,
  virtualEmployeeRouteCandidates,
} from '@/config/businessRoutePermissions'
import { getFirstAccessibleRouteFromStorage } from '@/utils/defaultRoute'

const virtualEmployeeRoutes: RouteRecordRaw[] = [
  {
    path: 'virtual-employee',
    component: () => import('@/views/virtual-employee/VirtualEmployeeLayout.vue'),
    redirect: () => getFirstAccessibleRouteFromStorage(virtualEmployeeRouteCandidates),
    meta: { permission: toAnyPermission(virtualEmployeeRouteCandidates) },
    children: [
      {
        path: 'dashboard',
        name: 'virtual-employee-dashboard',
        component: () => import('@/views/virtual-employee/VirtualEmployeeDashboard.vue'),
        meta: { title: '虚拟员工价值驾驶舱', permission: 'virtual_employee:dashboard:view' },
      },
      {
        path: 'config',
        name: 'virtual-employee-config',
        component: () => import('@/views/virtual-employee/VirtualEmployeeConfig.vue'),
        meta: { title: '虚拟员工配置工作台', permission: 'virtual_employee:config:view' },
      },
    ],
  },
]

export default virtualEmployeeRoutes
